import React from 'react';
import { NavLink } from 'react-router-dom';

const Drawer = ({ isOpen, onClose }) => {
  const navItems = [
    { path: "/", label: "Home", targetId: "pineridge-about-section" },
    { path: "/attractions", label: "Attractions", targetId: "attractions-main-content" },
    { path: "/about-us", label: "About us", targetId: "about-us-main-content" },
    { path: "/gallery", label: "Gallery", targetId: "gallery-main-content" },
    { path: "/experiences", label: "Experiences", targetId: "experiences-main-content" },
    { path: "/contact-us", label: "Contact us", targetId: "contact-us-main-content" },
    { path: "/terms-and-conditions", label: "Terms and Conditions", targetId: "terms-and-conditions-main-content" },
    { path: "/return-and-refund-policy", label: "Return and Refund Policy", targetId: "return-and-refund-policy-main-content" },

  ];

  return (
    <div className={`drawer ${isOpen ? 'open' : ''}`} id="drawer" aria-hidden={!isOpen}>
      <div className="drawer__panel" role="dialog" aria-modal="true" aria-label="Site menu">
        

        <nav className="drawer__nav">
          {navItems.map((item, index) => (
            <NavLink
              key={index}
              to={item.path}
              onClick={onClose}
              className={({ isActive }) => (isActive ? 'active' : '')}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="drawer__footer">
          <div className="call">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 16.92v2a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 3.18 2 2 0 0 1 4.11 1h2a2 2 0 0 1 2 1.72c.12.9.33 1.78.63 2.63a2 2 0 0 1-.45 2.11L7.09 8.91a16 16 0 0 0 6 6l1.45-1.2a2 2 0 0 1 2.11-.45c.85.3 1.73.51 2.63.63A2 2 0 0 1 22 16.92z" stroke="#b88943" strokeWidth="1.5"/></svg>
            <div>
              <div className="label">Reservation</div>
              <div className="num">+91 354 2254074</div>
              <div className="num">+91 93327 30219</div>
              <div className="label">(Available 8:00 AM – 10:00 PM)</div>
            </div>
          </div>
        </div>
      </div>
      <div className="drawer__scrim" id="drawerScrim" tabIndex="-1" aria-hidden="true" onClick={onClose}></div>
    </div>
  );
};

export default Drawer;